import * as barcodeTypes from "../../constants/barcodeTypes";

/**
 * @class Barcode
 */
export default class Barcode {
    /**
     * @param {Number}  id
     * @param {String}  code
     * @param {Number}  type
     * @param {Boolean} isLocal
     */
    constructor(id, code, type, isLocal) {
        this._id = id;
        this._code = code;
        this._type = type;
        this._isLocal = isLocal;
        this._format = this.getValidFormat(type);

        if (typeof this._id !== "number") {
            throw new Error("Invalid datatype of ID - Barcode");
        }
    }

    /**
     * @return {Number}
     */
    get id() {
        return this._id;
    }

    /**
     * @return {String}
     */
    get code() {
        return this._code;
    }

    /**
     * @return {Number}
     */
    get type() {
        return this._typey;
    }

    /**
     * @return {Boolean}
     */
    get isLocal() {
        return this._isLocal;
    }

    /**
     * @return {String}
     */
    get format() {
        return this._format;
    }

    getValidFormat = (type) => {
        switch (type) {
            case barcodeTypes.CODABAR:
                return "codabar";
            case barcodeTypes.CODE39:
            case barcodeTypes.CODE39_EXTENDED:
                return "code39";
            case barcodeTypes.CODE_128:
                return "code128";
            case barcodeTypes.EAN8:
                return "ean8";
            case barcodeTypes.EAN13:
                return "ean13";
            case barcodeTypes.UPC_A:
            case barcodeTypes.UPC_E:
                return "upc";
            default:
                return "code128";
        }
    };

    /**
     * @return {String}
     */
    toString() {
        return "Base (" + this._id + ")";
    }
}
